import { Badge } from "antd";
import useTranslation from "next-translate/useTranslation";
import { useEffect, useState } from "react";
import UserProgress from "shared/components/organisms/UserProgress";
import Widget from "shared/components/templates/Widget/index";
import ManyAuthors from "./Slider/index";
import { ColInfoUser, Content, MainContainer } from "./styles";

const Author = ({ author }) => {
  const { t } = useTranslation();

  const avatarUrl = author && author[0].photo;
  const displayName =
    (author && author[0].display_name) || (author && author[0].full_name);

  let bio = author && author[0].biography;
  if (bio && bio.length > 110) bio = `${bio.slice(0, 110)}...`;

  return (
    <>
      <Content>
        <ColInfoUser xs={24} md={24} lg={24} xl={9} xxl={8}>
          <UserProgress
            userSession={author[0]}
            image={avatarUrl}
            percent={60}
          />
          <h1 style={{ margin: "25px 0px 5px 0px", textAlign: "center" }}>
            {displayName}{" "}
          </h1>

          <div className="author-bio">
            <span>{bio}</span>
          </div>
        </ColInfoUser>
      </Content>
    </>
  );
};

const AboutAuthor = ({ course }) => {
  const { t } = useTranslation();

  return (
    <>
      {course && course.authors?.length > 0 && (
        <MainContainer>
          <Widget
            transparentDarkDisabled
            styleName="gx-card-tabs gx-card-tabs-right gx-card-profile"
            title={
              <>
                <span className="section-title">
                  {course.authors.length > 1
                    ? t("common:authors")
                    : t("common:author")}
                </span>
                <Badge
                  count={
                    (course.authors.length > 1 && course.authors.length) || 0
                  }
                />
              </>
            }
          >
            {course.authors.length > 1 ? (
              <ManyAuthors authors={course.authors} />
            ) : (
              <Author author={course.authors} />
            )}
          </Widget>
        </MainContainer>
      )}
    </>
  );
};

export default AboutAuthor;
